import { motion } from "framer-motion";
import { BRAND } from "../../data/menu";

const CHAPTERS = [
  {
    n: "01",
    title: "Our Story",
    body:
      "Puneri Kitchen began with a simple longing — the taste of home. Recipes carried from Pune's bustling peths and quiet wadas, cooked on slow flames, seasoned with patience. We don't chase trends; we honour tradition.",
  },
  {
    n: "02",
    title: "Prepared with Love",
    body:
      "Every bhakri is patted by hand, every masala freshly ground, every rassa simmered until the spices sing. No shortcuts, no preservatives — only fresh ingredients and the warmth of a family kitchen in every box we send out.",
  },
  {
    n: "03",
    title: "From Our Kitchen to Your Home",
    body:
      "Whether it's a weekday tiffin or a grand festive thali for the family, we cook the way we'd cook for our own. That is our promise — khamang chav, aapulkichi aathvan.",
  },
];

export default function Manifesto() {
  return (
    <section id="story" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-5 md:px-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="text-sm uppercase tracking-[0.3em] font-bold text-[#d97706] mb-16"
        >
          The Puneri Philosophy
        </motion.p>

        <div className="space-y-20 md:space-y-28">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="grid md:grid-cols-[0.9fr_1.1fr] gap-6 md:gap-12 items-start"
            >
              <div className="relative">
                <span className="font-accent text-[7rem] md:text-[11rem] leading-none text-[#7a1f1f]/12 select-none">
                  {c.n}
                </span>
                <h3 className="font-display text-3xl md:text-5xl font-semibold text-[#331818] -mt-8 md:-mt-16 relative">
                  {c.title}
                </h3>
              </div>
              <p className="text-lg md:text-xl leading-relaxed text-[#5c3a3a] md:pt-10 border-l-2 border-[#d97706]/40 pl-6">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
